<template>
  <div>
    <div class="flex justify-end">
      <div class="w-48 mr-4">
        <a-input
          v-model:value="params.keyword"
          :placeholder="'keyword'"
          testek="search-input"
          @keydown="handleKeyDownInput"
        >
          <template #addonAfter>
            <SearchOutlined />
          </template>
        </a-input>
      </div>
      <div class="btn-add font-bold">
        <a-button
          type="primary"
          testek="btn-add"
          @click="addData"
          :height="32"
          class="flex items-center"
        >
          <template #icon>
            <PlusCircleOutlined />
          </template>
          {{ $t("i18nCommon.AddGroup") }}
        </a-button>
      </div>
    </div>
    <BaseList
      :columns="columns"
      :data="Groups"
      :pagination="false"
      :isShowFiler="false"
      :isShowPrint="false"
      :isShowExport="false"
      :scroll="{ y: 'calc(100vh - 450px)' }"
      @editRow="editRow"
      @deleteRow="deleteRow"
      @loadDataFilter="loadDataFilter"
      ref="baseList"
    >
      <template #rightWidget="{ record }">
        <div class="flex">
          <div
            class="icon-24 mr-4 cursor-pointer btn-edit flex items-center justify-center"
            @click="editRow(record)"
            :title="$t('i18nCommon.Edit')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-edit icon-16"
            >
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </div>
          <div
            class="btn-delete icon-24 mr-4 cursor-pointer flex items-center justify-center"
            @click="deleteRow(record)"
            :title="$t('i18nCommon.Delete')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x icon-16"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
          <div
            class="icon-24 icon-user-role cursor-pointer"
            @click="addPolicy(record)"
            :title="$t('i18nCommon.AddPolicy')"
          ></div>
        </div>
      </template>
    </BaseList>

    <div v-if="isShow && groupSelected">
      <a-modal
        v-model:open="isShow"
        centered
        :ok-text="$t('i18nCommon.Save')"
        :cancel-text="$t('i18nCommon.Cancel')"
        @ok="handleOk"
        style="padding: 0; width: 100%; height: 100vh; top: 0"
        :body-style="{ height: '80vh', padding: 0, overflow: 'hidden' }"
      >
        <div class="h-full w-full">
          <div class="header-detail flex justify-between mb-6">
            <div class="font-bold text-xl">
              {{ groupSelected.groupName }}
            </div>
          </div>
          <div class="content mt-6">
            <div class="w-80 mt-4 mb-4">
              <a-input
                v-model:value="searchTextDetail"
                :placeholder="'keyword'"
                testek="search-input"
                @keydown="handleKeyDownInputResource"
              ></a-input>
            </div>
            <a-table
              :columns="columnPolicies"
              :data-source="filterResources"
              @change="handleTableChange"
              :scroll="scroll"
              testek="table"
              :customRow="rowEvents"
              :rowClassName="'row-table'"
              :pagination="false"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.checkbox && record[`${column.key}`]">
                  <div>
                    <a-checkbox
                      class="checkbox-policy"
                      v-model:checked="record[`${column.dataIndex}`]"
                      @change="() => {}"
                    ></a-checkbox>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModuleAuth, ModuleGroup } from "@/store/module-const";
import { Modal } from "ant-design-vue";
import { forEach } from "lodash";
export default {
  name: "GroupLIst",
  components: {
    BaseList,
  },
  data() {
    return {
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      params: {
        params: "",
      },
      columnPolicies: [],
      policy: {},
      isShow: false,
      searchTextDetail: "",
      resources: [],
      groupSelected: {},
    };
  },
  computed: {
    ...mapGetters(ModuleGroup, ["Groups"]),
    ...mapGetters(ModuleAuth, ["Resources"]),

    filterResources() {
      const me = this;
      if (!me.Resources || me.Resources.length <= 0) return;

      //Filter theo tenantId hoặc resourceName hoặc resourceCode
      const filteredResources = me.Resources.filter(
        (item) =>
          item.tenantId.toLowerCase().includes(me.searchTextDetail.toLowerCase()) ||
          item.resourceName.toLowerCase().includes(me.searchTextDetail.toLowerCase()) ||
          item.resourceCode.toLowerCase().includes(me.searchTextDetail.toLowerCase())
      );
      return filteredResources;
    },
  },
  async created() {
    const me = this;
    me.initDataStatic();
    await me.loadDataGrid();
  },
  methods: {
    ...mapActions(ModuleGroup, [
      "getGroups",
      "updateGroup",
      "deleteGroup",
      "updatePolicyGroup",
    ]),
    ...mapActions(ModuleAuth, [
      "getResources",
      "updatePolicy",
      "getPolicy",
      "createPolicy",
    ]),
    ...mapMutations(ModuleAuth, ["updateResourcesByScope", "updateResourceBySearchText"]),
    handleTableChange: _.debounce(async function (page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    }, 300),
    initDataStatic() {
      const me = this;
      me.columns = [
        {
          fixed: "left",
          title: me.$t("i18nCommon.GroupInfo.Code"),
          dataIndex: "groupCode",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.groupCode, b.groupCode),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.GroupInfo.Name"),
          dataIndex: "groupName",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.groupName, b.groupName),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.GroupInfo.Description"),
          dataIndex: "description",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.description, b.description),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.GroupInfo.Status"),
          dataIndex: "status",
          align: "center",
        },

        {
          title: me.$t("i18nCommon.GroupInfo.Action"),
          key: "rightWidget",
          fixed: "right",
          width: 150,
        },
      ];
    },

    async loadDataGrid() {
      const me = this;
      let payload = {
        ...me.payload,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getGroups(payload);
    },
    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      let payload = {
        ...me.payload,
        ...params,
        limit: me.pagination.pageSize,
        page: 1,
      };
      await me.getGroups(payload);
    }, 300),
    addData() {
      const me = this;
      me.$router.push("/create-group");
    },
    menuClick(menu) {
      const me = this;
      me.menuActive = menu;
    },
    editRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) return;

      me.$router.push("/create-group");
      setTimeout(() => {
        me.$emitter.emit("LoadEditGroup", {
          id: dataRow.groupId,
          mode: me.$enum.Mode.Edit,
        });
      }, 300);
    }, 300),

    deleteRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) {
        me.$messageNotification.messageNotification(
          me.$t("i18nCommon.DeleteGroupFail"),
          "warning"
        );
        return;
      }

      Modal.confirm({
        title: me.$t("i18nCommon.Confirm"),
        content: me.$t("i18nCommon.DeleteGroupConfirm", {
          name: dataRow.username,
        }),
        okText: me.$t("i18nCommon.Yes"),
        cancelText: me.$t("i18nCommon.No"),
        centered: true,
        async onOk() {
          let result = await me.deleteGroup({ id: dataRow.groupId });
          if (result && result.code == 200) {
            me.filterCancel();
            await me.loadDataFilter();
            //Thông báo
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteGroupSuccess")
            );
          } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
            me.$messageNotification.messageNotification(result.message, "warning");
          } else {
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteGroupFail"),
              "warning"
            );
          }
        },
      });
    }, 300),
    async handleKeyDownInput(event) {
      const me = this;
      //Hỗ trợ key enter
      if (event.keyCode === 13) {
        await me.getGroups({
          keyword: me.params.keyword,
        });
      }
    },

    filterCancel() {
      const me = this;
      me.params.keyword = "";
      me.$refs.baseList.filterCancel();
    },
    async addPolicy(dataRow) {
      const me = this;
      me.columnPolicies = [
        {
          fixed: "left",
          title: "Tentant Id",
          dataIndex: "tenantId",
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.GroupInfo.ResourceName"),
          dataIndex: "resourceName",
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.GroupInfo.ResourceCode"),
          dataIndex: "resourceCode",
          columncolumnKey: "name",
        },
        {
          title: "List",
          key: "list",
          checkbox: true,
          dataIndex: "isList",
        },
        {
          title: "Search",
          key: "search",
          checkbox: true,
          dataIndex: "isSearch",
        },
        {
          title: "Create",
          key: "create",
          checkbox: true,
          dataIndex: "isCreate",
        },
        {
          title: "Update",
          key: "update",
          checkbox: true,
          dataIndex: "isUpdate",
        },

        {
          title: "Delete",
          key: "delete",
          checkbox: true,
          dataIndex: "isDelete",
        },
        {
          title: "All",
          key: "all",
          checkbox: true,
          dataIndex: "isAll",
        },
      ];
      me.groupSelected = dataRow;
      await me.loadResources();

      if (!me.groupSelected.policyIds || me.groupSelected.policyIds.length <= 0) {
        //Tạo policy
        let policy = {
          description: `POLICY_${me.groupSelected.description}`,
          policyCode: `POLICY_${me.groupSelected.groupCode}`,
          policyName: `POLICY_${me.groupSelected.groupName}`,
          resourceScopes: [],
          status: "ACTIVE",
        };

        let policyInfoResult = await me.createPolicy(policy);
        if (policyInfoResult && policyInfoResult.data) {
          let policyInfo = policyInfoResult.data;
          me.groupSelected.policyId = policyInfo.policyId;
          //Cập nhật policy cho group
          //Cập nhật Policy này vào group
          await me.updatePolicyGroup({
            policyId: policyInfo.policyId,
            groupId: me.groupSelected.groupId,
          });
        } else if (
          policyInfoResult &&
          (policyInfoResult.statusCode == 400 || policyInfoResult.statusCode == 409)
        ) {
          this.$messageNotification.messageNotification(
            policyInfoResult.message,
            "warning"
          );
        }
      } else {
        me.groupSelected.policyId = me.groupSelected.policyIds[0];
      }

      //lấy thông tin policy
      me.policyInfo = await me.getPolicy({
        policyId: me.groupSelected.policyId,
      });
      me.updateResourcesByScope(me.policyInfo.scopes);

      me.isShow = true;
      me.ruleForm = {
        userId: dataRow.userId,
        default: false,
        leader: false,
      };
    },

    async loadResources() {
      const me = this;
      await me.getResources();
    },

    async handleOk() {
      const me = this;
      let payload = {
        policyId: me.policyInfo.policyId,
        policyCode: me.policyInfo.policyCode,
        policyName: me.policyInfo.policyName,
        status: "ACTIVE",
      };
      payload.resourceScopes = [];
      //chuẩn hóa lại dữ liệu để lưu
      me.Resources.forEach((item) => {
        let scopes = me.getScopeByChecked(item);
        if (scopes && scopes.length > 0) {
          payload.resourceScopes.push(...scopes);
        }
      });

      await me.updatePolicy(payload);
      me.isShow = false;
    },

    getScopeByChecked(item) {
      let scopes = [];
      if (item.isList) {
        scopes.push({
          tenantId: item.tenantId,
          resourceCode: item.resourceCode,
          resourceName: item.resourceName,
          scope: item[`list`].scope,
          scopeName: item[`list`].scopeName,
        });
      }
      if (item.isSearch) {
        scopes.push({
          tenantId: item.tenantId,
          resourceCode: item.resourceCode,
          resourceName: item.resourceName,
          scope: item[`search`].scope,
          scopeName: item[`search`].scopeName,
        });
      }
      if (item.isCreate) {
        scopes.push({
          tenantId: item.tenantId,
          resourceCode: item.resourceCode,
          resourceName: item.resourceName,
          scope: item[`create`].scope,
          scopeName: item[`create`].scopeName,
        });
      }
      if (item.isUpdate) {
        scopes.push({
          tenantId: item.tenantId,
          resourceCode: item.resourceCode,
          resourceName: item.resourceName,
          scope: item[`update`].scope,
          scopeName: item[`update`].scopeName,
        });
      }
      if (item.isDelete) {
        scopes.push({
          tenantId: item.tenantId,
          resourceCode: item.resourceCode,
          resourceName: item.resourceName,
          scope: item[`delete`].scope,
          scopeName: item[`delete`].scopeName,
        });
      }
      if (item.isAll) {
        scopes.push({
          tenantId: item.tenantId,
          resourceCode: item.resourceCode,
          resourceName: item.resourceName,
          scope: item[`list`].scope,
          scopeName: item[`list`].scopeName,
        });
      }

      return scopes;
    },

    handleKeyDownInputResource() {
      const me = this;
      me.updateResourceBySearchText(me.searchTextDetail);
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-default {
  background: #737373;
}

.gradient-background {
  background: linear-gradient(45deg, #07074f, #7f4fa2);

  &:hover {
    background: linear-gradient(45deg, #0b0b7e, #955dbd);
  }
}
</style>
